import React from 'react';
import './App.css';
import { LangProvider, useLang } from './i18n/LangContext';
import Header from './components/Header';
import Hero from './components/Hero';
import Section from './components/Section';
import Gallery from './components/Gallery';
import Amenities from './components/Amenities';
import Experiences from './components/Experiences';
import Village from './components/Village';
import HowToArrive from './components/HowToArrive';
import Contact from './components/Contact';
import Footer from './components/Footer';
import MobileContactBar from './components/MobileContactBar';

function Content() {
  const { t } = useLang();
  return (
    <>
      <Header />
      <main>
        <Hero />

        <Section id="about" index="01" eyebrow={t.sections.about} title={t.about.title}>
          <p className="text-[#4a4640] text-lg md:text-xl leading-relaxed max-w-3xl font-light">
            {t.about.body}
          </p>
        </Section>

        <Section
          id="house"
          index="02"
          eyebrow={t.sections.house}
          title={t.house.title}
          subtitle={t.house.sub}
          altBg
        >
          <Gallery />
        </Section>

        <Section id="amenities" index="03" eyebrow={t.sections.amenities} title={t.amenities.title}>
          <Amenities />
        </Section>

        <Section
          id="experiences"
          index="04"
          eyebrow={t.sections.experiences}
          title={t.experiences.title}
          subtitle={t.experiences.sub}
          altBg
        >
          <Experiences />
        </Section>

        <Section id="village" index="05" eyebrow={t.sections.village} title={t.village.title}>
          <Village />
        </Section>

        <Section id="arrive" index="06" eyebrow={t.sections.arrive} title={t.arrive.title} altBg>
          <HowToArrive />
        </Section>

        <Section id="contact" index="07" eyebrow={t.sections.contact} title={t.contact.title}>
          <Contact />
        </Section>
      </main>
      <Footer />
      <MobileContactBar />
      <div className="lg:hidden h-16" aria-hidden />
    </>
  );
}

function App() {
  return (
    <LangProvider>
      <div className="App bg-[#FDFBF7] text-[#2C2A26] min-h-screen">
        <Content />
      </div>
    </LangProvider>
  );
}

export default App;
